/**
* State model declaration for store flow steps
**/
export interface StepState {
  apiAction: string;
  previousStep: string;
  nextStep: string;
  error: string;
  initStep: string;
  isMobile: boolean;
  storeVin: boolean;
  storeGuid: boolean;
  vehicleAssociationDetails: object;
  storeGuidValue: string
}
/**
* Initial State model for store Steps
**/
export const initialStepState: StepState = {
  apiAction: '',
  previousStep: '',
  nextStep: '',
  error: '',
  initStep: '',
  isMobile: false,
  storeGuid: false,
  storeVin: false,
  vehicleAssociationDetails: {},
  storeGuidValue: ''
};
